var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg006Rope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 412 412",
    viewBox: "0 0 530 560",
    style: {
      enableBackground: "new 0 0 426.675 426.675"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m151 180c-16.569 0-30 14.431-30 31s13.431 30 30 30h210c16.569 0 30-13.431 30-30s-13.431-31-30-31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 301c0-16.569-13.431-30-30-30h-210c-16.569 0-30 13.431-30 30s13.431 30 30 30h210c16.569 0 30-13.431 30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 421c8.276 0 15-6.724 15-15v-45h-30v45c0 8.276 6.724 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c36.244 0 68.196-19.364 87.067-47.295-18.365-9.781-34.032-23.694-46.049-40.393-7.037 15.691-22.737 26.688-41.018 26.688-24.814 0-45-20.186-45-45v-45h-60v45c0 57.99 47.01 106 105 106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 90c-8.276 0-15 6.724-15 15v45h30v-45c0-8.276-6.724-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.983 86.688c7.036-15.691 22.736-26.688 41.017-26.688 24.814 0 45 20.186 45 45v45h60v-45c0-57.99-47.01-105-105-105-36.244 0-68.196 18.364-87.067 46.295 18.366 9.781 34.032 23.693 46.05 40.393z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.672 360.731c-.905.04-1.758.269-2.672.269h-58.488c7.335 50.821 50.636 90 103.488 90h15v-60h-15c-19.664 0-36.205-12.693-42.328-30.269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.328 150.269c.905-.04 1.758-.269 2.672-.269h58.488c-7.336-50.821-50.636-90-103.488-90h-15v60h15c19.664 0 36.205 12.693 42.328 30.269z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Rope);
export default __webpack_public_path__ + "static/media/006-rope.046ab7c0a0dd33ed6e29ae4e08186e50.svg";
export { ForwardRef as ReactComponent };